import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { AutoAwesome as EmbeddingIcon } from '@mui/icons-material';

interface ConfirmCreateEmbeddingDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tableName: string;
  generating?: boolean;
}

const ConfirmCreateEmbeddingDialog: React.FC<ConfirmCreateEmbeddingDialogProps> = ({
  open,
  onClose,
  onConfirm,
  tableName,
  generating = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={generating ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <EmbeddingIcon color="primary" fontSize="large" />
          <Typography variant="h6">Confirmar Generación de Embedding</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ¿Está seguro que desea generar el embedding para la siguiente tabla?
        </Typography>
        <Box
          sx={{
            p: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            borderLeft: '4px solid #1976d2',
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Tabla:
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {tableName}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Este proceso puede tardar unos momentos.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={generating}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={generating}
          startIcon={generating ? <CircularProgress size={20} /> : null}
        >
          {generating ? 'Generando...' : 'Generar Embedding'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCreateEmbeddingDialog;
